export default "__VITE_ASSET__CdPiD3gI__"